module.exports = __webpack_public_path__ + "static/media/euobnova.4e9bc318.jpg";